import React, { FC } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Box,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface InferenceViewerDialogProps {
  open: boolean;
  onClose: () => void;
  inferenceData: Record<string, any>[] | null | undefined;
}

const InferenceViewerDialog: FC<InferenceViewerDialogProps> = ({
  open,
  onClose,
  inferenceData,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Typography variant="h6">Inference Details</Typography>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent dividers sx={{ overflowY: 'auto' }}>
        <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}>
          {JSON.stringify(inferenceData, null, 2)}
        </pre>
      </DialogContent>
    </Dialog>
  );
};

export default InferenceViewerDialog;
